export default __webpack_public_path__ + "static/media/info16_datos_actualizados_JDE.d8024014.png";